import React, { useState } from 'react';
import LocationSelector from './components/LocationSelector';
import InventoryManagement from './components/InventoryManagement';

const App = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
  };

  const handleBackToLocations = () => {
    setSelectedLocation(null);
  };

  return (
    <div>
      <h1>Inventory System - RT, TL, & Stores</h1>
      {!selectedLocation ? (
        <LocationSelector onLocationSelect={handleLocationSelect} />
      ) : (
        <InventoryManagement 
          location={selectedLocation} 
          onBack={handleBackToLocations}
        />
      )}
    </div>
  );
};

export default App;